"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
}), !function(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: !0,
        get: all[name]
    });
}(exports, {
    AssertionFailure: function() {
        return AssertionFailure;
    },
    mustExist: function() {
        return mustExist;
    },
    notNullish: function() {
        return notNullish;
    },
    nullish: function() {
        return nullish;
    }
});
const _Format = require("./Format");
class AssertionFailure extends Error {
    constructor(...args){
        super((0, _Format.format)(args));
    }
}
function mustExist(value, message) {
    if (notNullish(value)) return value;
    throw new AssertionFailure(message || 'Value is expected but got none.');
}
function notNullish(value) {
    return !nullish(value);
}
function nullish(value) {
    return null == value;
}

//# sourceMappingURL=data:application/json;base64,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